// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bundle-discount-section[data-v-ad2515ce]{display:flex;align-items:baseline;gap:6px;margin:8px 0 16px}.bundle-discount-section .bundle-discount-label[data-v-ad2515ce]{flex:0 0 auto;padding:4px 6px;color:#fff;line-height:16px;font-size:13px;border-radius:4px}.bundle-discount-section .bundle-discount-title[data-v-ad2515ce]{min-width:0;font-size:13px;overflow-wrap:anywhere}", ""]);
// Exports
module.exports = exports;
